module.exports = __webpack_public_path__ + "img/surprised.815ad832.webp";